import type { FC, TdHTMLAttributes } from 'react';

export type TCellProps = TdHTMLAttributes<HTMLTableCellElement> & {
  index?: number;
};

export const TCell: FC<TCellProps> = ({ children, width = '44px', ...props }) => {
  return (
    <td style={{ width, fontSize: '14px' }} {...props}>
      {children}
    </td>
  );
};
